import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import loginImage from '../assets/images/LoginSignup.jpg'

export default function Login() {
  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => setShowPassword(!showPassword)

  return (
    <div className="min-vh-100 bg-white">
      <div className="container-fluid px-0">
        <div className="row g-0 min-vh-100 align-items-stretch shadow-lg rounded-4 overflow-hidden">
          {/* LEFT PANEL */}
          <div
            className="col-12 col-lg-6 position-relative d-flex flex-column justify-content-center text-white p-5"
            style={{
              backgroundImage: `url(${loginImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0,0,0,0.6)' }} />

            <div className="position-relative">
              <h1 className="fw-bold display-4 mb-4">Lucentum Basketball Universe</h1>
              <ul className="fs-6 ps-3" style={{ listStyle: 'disc' }}>
                <li className="mb-2">Immerse yourself in the world of Lucentum Basketball</li>
                <li className="mb-2">Get exclusive access to match tickets, stats, and insights</li>
                <li className="mb-2">Engage with top players and team mentors</li>
                <li className="mb-2">Collaborate with fans, sponsors, and teammates</li>
                <li className="mb-2">Unlock rewards with every game and event</li>
              </ul>
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="col-12 col-lg-6 bg-white d-flex align-items-center justify-content-center">
            <form className="w-100 px-4" style={{ maxWidth: 440, fontFamily: 'Poppins, sans-serif' }}>
              <h2 className="text-center fw-semibold mb-4" style={{ fontSize: '22px' }}>Login</h2>

              <div className="vstack gap-3">
                <input
                  type="email"
                  className="form-control p-2 rounded-2 border-dark-subtle"
                  placeholder="Email"
                  required
                  style={{ fontSize: '15px' }}
                />

                <div className="position-relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control p-2 rounded-2 border-dark-subtle"
                    placeholder="Password"
                    required
                    style={{ fontSize: '15px' }}
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y pe-3 text-secondary"
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                    onClick={togglePassword}
                  >
                    &#128065;
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-2">
                <a href="#" className="text-decoration-none text-dark fw-medium" style={{ fontSize: '14px' }}>
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="btn w-100 py-2 mt-3 fw-semibold"
                style={{ backgroundColor: '#0440A8', color: '#fff', fontSize: '15px', borderRadius: '6px' }}
              >
                Login
              </button>

              <p className="text-center mt-3 mb-0" style={{ fontSize: '14px' }}>
                Not a Member yet?{' '}
                <Link to="/register" className="text-decoration-none fw-semibold text-dark">
                  Register
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}